import { GM_Point } from "./WeatherTypes";
import { SpotterWave, SpotterWind } from "./SpotterTypes";

export type MapBounds = {
  bounds: mapboxgl.LngLatBoundsLike;
  options?: mapboxgl.FitBoundsOptions;
};

// for presentation of spotter data on the map, because the raw spotters have
// functions and promises in them that are best normalized by the view model
export type SpotterMapData = {
  label: string;
  position: GM_Point;
  id: string;
  timestamp: string;
  wind?: SpotterWind; // m / s (some older spotters do not provide wind)
  waves: SpotterWave; // m
};

export enum QUERY_KEY_STRINGS {
  SPOTTER_REALTIME = "spotter-all-realtime",
  TROPICAL_STORMS = "StormGlassAPI.topicalStorms",
}
